import Model from 'src/storage/base';

export class CreateTreatmentModel extends Model {
  id = 'CreateTreatmentModel';
  defaultState = () => ({
    files: [],
    media: [],
    clinics: [],
    medicines: [this.defaultMedicines()],
    recommendations: [this.defaultRecommendations()],
    tagRecommendations: [this.defaultTagRecommendations()],
    current: 'recent'
  });
  defaultMedicines = () => ({
    name: '',
    doze: 1,
    days: 1,
    period: 'any',
    times: []
  });
  defaultRecommendations = () => ({
    type: '',
    detail: ''
  });
  defaultTagRecommendations = () => ({
    text: '',
    tags: []
  });
  apiConfig = {
    create: {
      url: 'treatment/create',
      validation: {
        partnerId: 'userId',
        medicines: 'medicines',
        // recommendations: 'recommendations',
        diagnosis: 'diagnosis',
        files: 'files',
        description: 'description',
        note: 'note',
        // recommendation: 'recommendation',
        nextUpdateAmount: 'nextUpdateAmount',
        nextUpdateUnit: 'nextUpdateUnit'
      },
      cancellable: true
    },
    treatment_tags: {
      url: 'treatment/tags',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  create = (cb) => {
    let req = {
      messageId: this.state.messageId,
      treatmentId: this.state.treatmentId,
      partnerId: this.state.editItem?.partnerId || this.state.partnerId,
      medicines: this.state.medicines,
      tagRecommendations: this.state.tagRecommendations,
      // recommendations: this.state.recommendations,
      diagnosis: this.state.diagnosis,
      note: this.state.note,
      files: [],
      description: this.state.description,
      // recommendation: this.state.recommendation,
      nextUpdateAmount: this.state.nextUpdateFlg ? this.state.nextUpdateAmount : 0,
      nextUpdateUnit: this.state.nextUpdateFlg ? this.state.nextUpdateUnit : '',
      clinicId: this.state.user.clinicIds?.length ? this.state.user.clinicIds[0] : 0,
      hospitalId: this.state.hospitalId
    };
    req.media = this.state.media.map(({ file, ...item }) => {
      if (file) {
        req.haveFiles = true;
        req[item.id] = file;
        return item;
      }
      return item;
    });
    this.api('create', req, (err, data, success) => {
      cb(err, data, success);
      if (success) {
        this.resetAddTreatment();
      }
    });
  };

  resetAddTreatment = (editItem, partnerId) => {
    this.resetApi();
    let edit = (editItem && editItem.data) || {};
    this.setState({
      messageId: editItem?.id || 0,
      treatmentId: editItem?.treatmentId || edit.treatmentId || 0,
      medicines: edit.medicines || [this.defaultMedicines()],
      recommendation: edit.recommendation || '',
      recommendations: edit.recommendations || [this.defaultRecommendations()],
      tagRecommendations: edit.tagRecommendations || [this.defaultTagRecommendations()],
      diagnosis: edit.diagnosis || '',
      description: edit.description || '',
      files: [],
      media: editItem?.media || [],
      note: edit.note || '',
      nextUpdateAmount: edit.nextUpdateAmount || 0,
      nextUpdateUnit: edit.nextUpdateUnit || 'days',
      nextUpdateFlg: edit.nextUpdateFlg || true,
      clinicId: editItem?.clinicId || 0,
      hospitalId: editItem?.hospitalId,
      editItem: editItem || null,
      mediaId: Date.now(),
      partnerId
    });
  };

  addMoreMedicine = () => {
    const medicines = this.input('medicines');
    medicines.push(this.defaultMedicines());
    this.handleChange('medicines', [...medicines]);
  };

  delMedicine = (delIds) => {
    const medicines = this.input('medicines');
    this.handleChange('medicines', [...medicines.filter((item, i) => delIds.indexOf(i) === -1)]);
  };

  addMoreRecommendation = () => {
    const recommendations = this.input('recommendations');
    recommendations.push(this.defaultRecommendations());
    this.handleChange('recommendations', [...recommendations]);
  };

  delRecommendation = (delIds) => {
    const recommendations = this.input('recommendations');
    this.handleChange('recommendations', [
      ...recommendations.filter((item, i) => delIds.indexOf(i) === -1)
    ]);
  };

  addMoreTagRecommendations = () => {
    const recommendations = this.input('tagRecommendations');
    recommendations.push(this.defaultTagRecommendations());
    this.handleChange('tagRecommendations', [...recommendations]);
  };

  delTagRecommendations = (delIds) => {
    const recommendations = this.input('tagRecommendations');
    this.handleChange('tagRecommendations', [
      ...recommendations.filter((item, i) => delIds.indexOf(i) === -1)
    ]);
  };

  remove = (id, item, cb) => {
    this.emit('treatment_remove', id);
    this.api('remove', { id }, (err, res, success) => {
      if (!success) {
        // TODO - restore item
      }
      cb && cb(err, res, success);
    });
  };
}

const model = new CreateTreatmentModel();
export default model;
